import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';

const useBulletinUpdate = () => {
  const { mutate: save, ...saveMutation } = api.bulletinUpdate.save.useMutation(
    useHandleTrpcMutation()({}),
  );

  const { mutate: publish, ...publishMutation } =
    api.bulletinUpdate.publish.useMutation(useHandleTrpcMutation()({}));

  return {
    saving: saveMutation.isPending || publishMutation.isPending,
    save,
    publish,
  };
};

export default useBulletinUpdate;
